import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getArticleFileDataAsync,
  loadPublicArticles,
  registerUserInToCourse,
} from "../services/learnService";
import Swal from "sweetalert2";
import { AxiosResponse } from "axios";
import { setStatus } from "../features/learnSlice";
import { ArticleType, DataStatus } from "../types/LearnTypes";
import { dispatchErrorMessageSnackbar } from "../../utils/helpers/helper";

const dispatchFailure = (dispatch: any, articleType: ArticleType) => {
  dispatch(setStatus({ articleType: articleType, status: DataStatus.failed }));
};

export const getArticleFileDataAction = createAsyncThunk(
  "learn/getCourse",
  async (
    { articleId, fileId }: { articleId: string; fileId: string },
    thunkAPI
  ) => {
    try {
      const response: AxiosResponse<any, any> = await getArticleFileDataAsync(
        articleId,
        fileId
      );
      if (response.data && response.status === 200) {
        return thunkAPI.fulfillWithValue(response.data);
      }
      dispatchFailure(thunkAPI.dispatch, ArticleType.articleInfo);
      dispatchErrorMessageSnackbar(
        thunkAPI.dispatch,
        "Sorry unable to load this article now, please try again later"
      );
      return thunkAPI.rejectWithValue({
        message: "failed to get article data",
      });
    } catch (error: any) {
      if (error?.response?.status === 403) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "You are not authorized to access this course!",
          allowEscapeKey: false,
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: true,
        }).then((result) => {
          // hard redirect to landing page
          window.location.href = "/";
        });
      } else {
        dispatchErrorMessageSnackbar(
          thunkAPI.dispatch,
          "Sorry unable to load this article now, please try again later"
        );
      }
      dispatchFailure(thunkAPI.dispatch, ArticleType.articleInfo);
      return thunkAPI.rejectWithValue({
        message: "Failed to get article data",
      });
    }
  }
);

export const loadPublicArticlesAction = createAsyncThunk(
  "learn/load/public/articles",
  async (
    {
      page,
      resultsPerPage,
      articleType,
      searchString,
      filterString,
    }: {
      page: number;
      resultsPerPage: number;
      articleType: ArticleType;
      searchString?: string;
      filterString?: string;
    },
    thunkAPI
  ) => {
    try {
      const response: AxiosResponse<any, any> = await loadPublicArticles(
        page,
        resultsPerPage,
        articleType,
        searchString,
        filterString
      );
      if (response.data && response.status === 200) {
        // console.log(
        //   "Public Articles",
        //   response.data,
        //   "articleType",
        //   articleType
        // );
        return thunkAPI.fulfillWithValue({
          data: response.data,
          articleType: articleType,
        });
      }
      dispatchFailure(thunkAPI.dispatch, articleType);
      return thunkAPI.rejectWithValue({
        message: "Failed to load public articles",
      });
    } catch (error: any) {
      dispatchFailure(thunkAPI.dispatch, articleType);
      return thunkAPI.rejectWithValue({
        message: "Failed to load public articles",
      });
    }
  }
);

export const registerInToCourseAction = createAsyncThunk(
  "learn/register/public/course",
  async ({ courseId }: { courseId: string }, thunkAPI) => {
    try {
      const response: AxiosResponse<any, any> = await registerUserInToCourse(
        courseId
      );
      return thunkAPI.fulfillWithValue(response);
    } catch (error: any) {
      if (error.response) {
        if (error.response.status === 409) {
          return thunkAPI.fulfillWithValue(error.response);
        }
        return thunkAPI.rejectWithValue(error.response);
      }
      return thunkAPI.rejectWithValue({
        message: "Failed to register public course",
      });
    }
  }
);
